import { render, staticRenderFns } from "./TutorialContestuale.vue?vue&type=template&id=4c3a1ea6&scoped=true"
import script from "./TutorialContestuale.vue?vue&type=script&lang=js"
export * from "./TutorialContestuale.vue?vue&type=script&lang=js"
import style0 from "./TutorialContestuale.vue?vue&type=style&index=0&id=4c3a1ea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3a1ea6",
  null
  
)

export default component.exports